import formatStringToPascalCase from './formatters/formatStringToPascalCase';

const getRoomName = (itinerary) => {
  if (!itinerary || !itinerary.selectedProduct
    || !itinerary.selectedProduct.rooms
    || !itinerary.selectedProduct.rooms[0]) return '';

  const room = itinerary.selectedProduct.rooms[0];

  const roomType = room.type || '';
  const bedType = room.bedTypes && Array.isArray(room.bedTypes)
        && room.bedTypes.length > 0 ? room.bedTypes.join(', ') : '';

  if (!roomType && !bedType) return '';

  return formatStringToPascalCase(
    roomType && bedType ? `${roomType} - ${bedType}` : `${roomType}${bedType}`,
  );
};

const getHotelName = (itinerary) => {
  if (!itinerary) return '';

  return itinerary.hotel && itinerary.hotel.name
    ? formatStringToPascalCase(itinerary.hotel.name) : '';
};

const getHotelAndRoomNames = (itinerary) => {
  if (!itinerary) return '';

  const hotelName = getHotelName(itinerary);
  const roomName = getRoomName(itinerary);

  return `${hotelName}${roomName ? `, ${roomName}` : ''}`;
};

export { getHotelName, getRoomName };
export default getHotelAndRoomNames;
